/**
 * Created by showzyl on 2016/11/2.
 */


;(function (win) {
	'use strict'

	win.mv_util = {};

	mv_util.test = function () {
		console.log('test');
	}

	mv_util.http2https = function (adUnits) {
		var httpsMap = {
			'http://cdn-adn.rayjump.com': 'https://cdn-adn-https.rayjump.com',
			'http://res.rayjump.com': 'https://res-https.rayjump.com',
			'http://d11kdtiohse1a9.cloudfront.net': 'https://res-https.rayjump.com'
		};
		for (var i = 0; i < adUnits.length; i++) {
			for (var k in adUnits[i]) {
				for (var key in httpsMap) {
					var reg = new RegExp('' + key + '');
					if (reg.test(adUnits[i][k])) {
						adUnits[i][k] = adUnits[i][k].replace(reg, httpsMap[key])
					}
				}
			}
		}
	}

	mv_util.getUrlParams = function (url) {
		var i;
		url = url || window.location;
		url = url.indexOf ? url : url.toString();
		url = decodeURIComponent(url);

		var paramStringStart = url.indexOf("?") + 1,
			paramStringEnd = (url.indexOf("#") === -1) ?
				url.length :
				url.indexOf("#"),
			paramString = url.slice(paramStringStart, paramStringEnd),
			keysAndValues = paramString.split('&'),
			paramsObject = {};

		for (i = 0; i < keysAndValues.length; i++) {
			var keyValue = keysAndValues[i].split('=');

			if (keyValue[0].slice(-2) === "[]") {
				var key = keyValue[0].slice(0, -2);
				paramsObject[key] = paramsObject[key] || [];
				paramsObject[key].push(keyValue[1]);
			} else {
				paramsObject[keyValue[0]] = keyValue[1];
			}
		}

		return paramsObject;
	}

	mv_util.hybirdEvent = function (opt) {
		var sClass = opt.sClass || 'OfferWall';
		window.WindVane.call(sClass, opt.hybirdFn, opt.params, function (res) {
			opt.succ && opt.succ(res);
		}, function (e) {
			opt.err && opt.err(e);
		})
	}

	mv_util.createEl = function (tagName, targetEl, attr) {
		var el = document.createElement(tagName);
		var key;
		if (attr) {
			for (key in attr) {
				el[key] = attr[key];
			}
		}
		if (targetEl) {
			targetEl.appendChild(el);
		} else {
			document.body.appendChild(el);
		}
		return el;
	}

	mv_util.getEl = function (el, tagName) {
		el = el.replace(/^\s|\s$/g, '');
		// # id . class tag
		var first = el.substr(0, 1);
		//console.log(first);

		if (first === '#') {
			return document.getElementById(el.substr(1, el.length))
		}

		if (first === '.') {
			return document.getElementsByClassName(el.substr(1, el.length))
		}

		return document.getElementsByTagName(el);

	}

	mv_util.rmEl = function (el) {
		var oParent = el.parentNode;
		if (oParent) {
			oParent.removeChild(el);
		}
	}

	mv_util.addClass = function (el, className) {
		var reg = new RegExp('' + className + '');
		if (!reg.test(el.className)) {
			// if dosent exsist
			el.className += (' ' + className);
		}
	}

	mv_util.rmClass = function (el, className) {
		var reg = new RegExp('' + className + '');
		if (reg.test(el.className)) {
			el.className = el.className.replace(reg, '');
		}
	}

	mv_util.attr = function (el, obj, value) {
		if(arguments.length === 2 && typeof obj === 'string'){
			return el.getAttribute(obj);
		}
		if(typeof obj === 'string'){
			el.setAttribute(obj, value);
		}else{
			for(var key in obj){
				el.setAttribute(key, obj[key]);
			}
		}
	}

	mv_util.language = function (cb) {
		var type = navigator.appName;
		var lang;
		if (type == "Netscape") {
			lang = navigator.language
		} else {
			lang = navigator.userLanguage
		}
		lang = lang.substr(0, 2);
		switch (lang) {
			case 'en':
				return 'en';
				break;
			case 'zh':
				return 'zh';
				break;
			default:
				return 'other';
		}
	}

	mv_util.tips = function (msg, cb) {
		var tips_center = document.getElementById('tips_center');
		tips_center.innerHTML = msg;
		tips_center.style.display = 'block';
		cb && cb()
		clearTimeout(this.timmer)
		this.timmer = setTimeout(function () {
			tips_center.innerHTML = '';
			tips_center.style.display = 'none';
		}, 2000)
	}

	mv_util.ajax = function (type, url, data, success, failed) {
		// 创建ajax对象
		var xhr = null;
		if (window.XMLHttpRequest) {
			xhr = new XMLHttpRequest();
		} else {
			xhr = new ActiveXObject('Microsoft.XMLHTTP')
		}

		var type = type.toUpperCase();
		// 用于清除缓存
		var random = Math.random();

		if (typeof data == 'object') {
			var str = '';
			for (var key in data) {
				str += key + '=' + data[key] + '&';
			}
			data = str.replace(/&$/, '');
		}
		type = type.toUpperCase();
		if (type == 'GET') {
			if (data) {
				xhr.open('GET', url + '?' + data, true);
			} else {
				xhr.open('GET', url + '?t=' + random, true);
			}
			xhr.send();

		} else if (type == 'POST') {
			xhr.open('POST', url, true);
			// 如果需要像 html 表单那样 POST 数据，请使用 setRequestHeader() 来添加 http 头。
			xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
			xhr.send(data);
		}

		// 处理返回数据
		xhr.onreadystatechange = function () {
			if (xhr.readyState == 4) {
				if (xhr.status == 200) {
					if (typeof xhr.responseText === 'string') {
						success(system.deserialize(xhr.responseText));
					} else {
						success(xhr.responseText);
					}
				} else {
					if (failed) {
						failed(xhr.status);
					}
				}
			}
		}

	}

	// 文档高度
	mv_util.getDocumentTop = function () {
		var scrollTop = 0, bodyScrollTop = 0, documentScrollTop = 0;
		if (document.body) {
			bodyScrollTop = document.body.scrollTop;
		}
		if (document.documentElement) {
			documentScrollTop = document.documentElement.scrollTop;
		}
		scrollTop = (bodyScrollTop - documentScrollTop > 0) ? bodyScrollTop : documentScrollTop;
		return scrollTop;
	}

	// 可视窗口高度
	mv_util.getWindowHeight = function () {
		var myHeight = 0;
		if( typeof( window.innerWidth ) == 'number' ) {
			//Non-IE
			myHeight = window.innerHeight;
		} else if( document.documentElement && document.documentElement.clientHeight ) {
			//IE 6+ in 'standards compliant mode'
			myHeight = document.documentElement.clientHeight;
		} else if( document.body && document.body.clientHeight ) {
			//IE 4 compatible
			myHeight = document.body.clientHeight;
		}
		return myHeight;
	}

	// 可视窗口宽度
	mv_util.getWindowWidth = function () {
		var myWidth = 0;
		if( typeof( window.innerWidth ) == 'number' ) {
			//Non-IE
			myWidth = window.innerWidth;
		} else if( document.documentElement && document.documentElement.clientWidth ) {
			//IE 6+ in 'standards compliant mode'
			myWidth = document.documentElement.clientWidth;
		} else if( document.body && document.body.clientWidth ) {
			//IE 4 compatible
			myWidth = document.body.clientWidth;
		}
		return myWidth;
	}

	// 滚动条滚动高度
	mv_util.getScrollHeight = function () {
		var scrollHeight = 0, bodyScrollHeight = 0, documentScrollHeight = 0;
		if (document.body) {
			bodyScrollHeight = document.body.scrollHeight;
		}
		if (document.documentElement) {
			documentScrollHeight = document.documentElement.scrollHeight;
		}
		scrollHeight = (bodyScrollHeight - documentScrollHeight > 0) ? bodyScrollHeight : documentScrollHeight;
		return scrollHeight;
	}

	mv_util.rnd = function (m, n) {
		return parseInt(Math.random() * (m - n) + n);
	}

	mv_util.device = function () {
		var u = navigator.userAgent;
		var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
		var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
		return {
			isAndroid: isAndroid,
			isiOS: isiOS
		}
	}


	/**
	 * @description 得到指定的cookie值
	 * @param {String} name cookie名称【必选】
	 * @param {Boolean} [encode] 是否encodeURIComponent 默认false【可选】
	 * @return 指定cookie的值
	 * @example Q_core.cookie.get('name')
	 * @method
	 */
	mv_util.getCookie = function(name, encode) {
		var m = document.cookie.match(new RegExp("(^| )" + name + "=([^;])*", "gi")),
			v = !m ? '' : m[0].split(name + '=')[1];
		return (!!encode ? v : decodeURIComponent(v));
	};
	/**
	 * @description set设置cookie, del删除cookie,当expires小于0时即为删除cookie
	 * @param {Object} options 【必选】
	 * @param {String} options.name cookie的名称【必选】
	 * @param {String} options.value cookie的值【必选】
	 * @param {Number} [options.expires] cookie的过期时间，为整数，单位为天，为负时删除cookie【可选】
	 * @param {String} [options.domain]  指定cookie所属的域【可选】
	 * @param {String} [options.path]  指定cookie 的路径【可选】
	 * @param {Boolean} [options.secure]  是否安全传输 当协议为https时才可用【可选】
	 * @param {Boolean} [options.encode]  是否对值进行encodeURIComponent【可选】
	 * @example Q_core.cookie.set({name:'test',value:'ok'});
	 * @method
	 */
	mv_util.setCookie = function(options) {
		var ck = [];
		ck.push(options.name + '=');
		if (options.value) {
			ck.push(!!options.encode ? options.value : encodeURIComponent(options.value));
			//是否encodeURIComponent
		}
		if (options.expires) {
			var d = new Date();
			d.setHours(0);
			d.setMinutes(0);
			d.setSeconds(0);
			d.setTime(d.getTime() + options.expires * 86400000);
			//24 * 60 * 60 * 1000
			ck.push(';expires=' + d.toGMTString());
		}
		if (options.domain) {
			ck.push(';domain=' + options.domain);
		}
		ck.push(';path=' + (options.path || '/'));
		if (options.secure) {
			ck.push(';secure');
		}
		document.cookie = ck.join('');
	};


	/*
	 * Interfaces:
	 * utf8 = utf16to8(utf16);
	 * utf16 = utf8to16(utf8);
	 */
	mv_util.utf16to8 = function (str) {
		var out, i, len, c;
		out = "";
		len = str.length;
		for (i = 0; i < len; i++) {
			c = str.charCodeAt(i);
			if ((c >= 0x0001) && (c <= 0x007F)) {
				out += str.charAt(i);
			} else if (c > 0x07FF) {
				out += String.fromCharCode(0xE0 | ((c >> 12) & 0x0F));
				out += String.fromCharCode(0x80 | ((c >> 6) & 0x3F));
				out += String.fromCharCode(0x80 | ((c >> 0) & 0x3F));
			} else {
				out += String.fromCharCode(0xC0 | ((c >> 6) & 0x1F));
				out += String.fromCharCode(0x80 | ((c >> 0) & 0x3F));
			}
		}
		return out;
	}

	/**
	 * @function escapeHTML 转义html脚本 < > & " '
	 * @param a -
	 *            字符串
	 */
	mv_util.escapeHTML = function(a){
		a = "" + a;
		return a.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;");;
	}

	/**
	 * @function unescapeHTML 还原html脚本 < > & " '
	 * @param a -
	 *            字符串
	 */
	mv_util.unescapeHTML = function(a){
		a = "" + a;
		return a.replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&amp;/g, "&").replace(/&quot;/g, '"').replace(/&apos;/g, "'");
	}

	mv_util.utf8to16 = function (str) {
		var out, i, len, c;
		var char2, char3;
		out = "";
		len = str.length;
		i = 0;
		while (i < len) {
			c = str.charCodeAt(i++);
			switch (c >> 4) {
				case 0:
				case 1:
				case 2:
				case 3:
				case 4:
				case 5:
				case 6:
				case 7:
// 0xxxxxxx
					out += str.charAt(i - 1);
					break;
				case 12:
				case 13:
// 110x xxxx 10xx xxxx
					char2 = str.charCodeAt(i++);
					out += String.fromCharCode(((c & 0x1F) << 6) | (char2 & 0x3F));
					break;
				case 14:
// 1110 xxxx 10xx xxxx 10xx xxxx
					char2 = str.charCodeAt(i++);
					char3 = str.charCodeAt(i++);
					out += String.fromCharCode(((c & 0x0F) << 12) |
						((char2 & 0x3F) << 6) |
						((char3 & 0x3F) << 0));
					break;
			}
		}
		return out;
	}

	mv_util.clearConsole = function () {
		var method;
		var _noop = function () {
		};
		var methods = [
			'assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error',
			'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log',
			'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd',
			'timeline', 'timelineEnd', 'timeStamp', 'trace', 'warn'
		];
		var length = methods.length;
		var console = (window.console = window.console || {});

		while (length--) {
			method = methods[length];
			// Only stub undefined methods.
			if (console[method]) {
				console[method] = _noop;
			}
		}
		if (typeof document.write === "function") {
			document.write = _noop;
		}
		if (typeof win.alert === "function") {
			win.alert = _noop;
		}
	}
	
	

	

})(window);












